import api from './api';
import OAuthActions from 'actions/OAuthActions';

const OAuthSource = {
  // Fetch the status of all Integrations
  fetchStatus: {
    remote(state) {
      return api.get('/oauth');
    },
    loading: OAuthActions.fetchStatusLoading,
    success: OAuthActions.fetchStatusSuccess,
    error: OAuthActions.fetchStatusError,
  },
  redirectUrl: {
    remote(state, apiName) {
      return api.get('/oauth/' + apiName);
    },
    loading: OAuthActions.redirectUrlLoading,
    success: OAuthActions.redirectUrlSuccess,
    error: OAuthActions.redirectUrlError,
  },
};

export default OAuthSource;
